module.exports = __webpack_public_path__ + "img/state_222.984fd4da.jpg";